import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'timeconvert'
})

export class TimeconvertPipe implements PipeTransform {

  transform(secs:any): string {
   return moment.utc(secs*1000).format('HH:mm:ss');
  }

}
